import styled from 'styled-components';

import Button from '@components/Button';

import ResponsiveDrawer from './ResponsiveDrawer';

export const StyledResponsiveListingFilter = styled.div`
  width: 100%;
  padding: 12px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 12px;
`;

export const FilterSortButton = styled(Button)`
  display: flex;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  align-items: center;

  background-color: ${({ theme }) => theme.palette.white};
  width: 290px;

  max-width: 320px;
  margin: 16px auto;
  padding: 22px 50px;
  justify-content: center;
`;

export const ResponsiveListingFilterButtonLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.darkGray};
  margin-left: 5px;
`;

export const StyledFilterDrawer = styled(ResponsiveDrawer)`
  &&& {
    .setur-drawer-header {
      height: 64px;
      display: flex;
      align-items: center;
    }

    .setur-drawer-body {
      padding: 0px 12px 50px 12px;
      margin-bottom: 0px;
      overflow: auto;
      background-color: rgb(247, 247, 247) !important;
    }

    .setur-drawer-footer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      border-top: 1px solid ${({ theme }) => theme.palette.grey300};
      background: ${({ theme }) => theme.palette.white};
      padding: 12px;

      & > div {
        width: 100%;
      }
    }

    .setur-drawer-title {
      width: fit-content;
      margin: 0 auto;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      color: ${({ theme }) => theme.palette.white};
    }

    .setur-drawer-header-title button svg path {
      fill: ${({ theme }) => theme.palette.whiteAlpha600};
    }

    .setur-drawer-close {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .setur-collapse {
      padding: 0;
      margin: 0;
    }

    div.setur-collapse-header {
      padding: 0px !important;
      height: 30px;
    }

    .collapse-item-icon {
      right: 20px !important;
    }

    .setur-collapse-content-box {
      padding: 0px;
    }

    .collapse-header-icon {
      width: 24px;
      height: 24px;
    }

    .collapse-header-icon-small {
      width: 20px;
      height: 20px;
    }
  }
`;

export const CollapseHeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
`;

export const CollapseHeaderLabel = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
`;

export const ButtonElement = styled.div`
  flex: 1;
`;

export const CollapseHeaderSubLabel = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const FilterAndSortContentWrapper = styled.div`
  height: 100%;
`;

export const FilterAndSortWrapper = styled.div`
  grid-row: 1/2;
  overflow: auto;
`;

export const FilterAndSortApplyDiv = styled.div`
  grid-row: 2/3;
  padding: 15px;
`;

export const StyledFilters = styled.div`
  .responsive-filter-collapse-white .setur-collapse-content-box {
    background-color: ${({ theme }) => theme.palette.white};
    padding: 20px 15px;
  }

  .collapse-header-extra {
    position: absolute;
    right: 50px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }

  .collapse-header-extra-label {
    margin: 1px 5px 1px 0;
    opacity: 0.5;

    font-size: 14px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.veryLightBlack};
  }

  .collapse-header-sub-title {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.veryLightBlack};
  }
`;

export const StyledResponsiveFilterCollapse = styled.div`
  padding-top: 12px;
  & > * {
    margin-bottom: 20px;
  }

  div.setur-collapse-header {
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.veryLightBlack};
  }
`;

export const StyledResponsiveRegions = styled.div`
  & > div {
    max-height: 250px;
    overflow: auto;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      padding: 0px;

      .setur-tree-treenode {
        margin-bottom: 10px;
      }
    }
  }

  .listing-filter-region-title {
    font-size: 16px;
  }

  .setur-tree-title {
    font-size: 14px;
    padding-top: 2px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .setur-tree-checkbox-inner {
      width: 20px;
      height: 20px;
      border-radius: 2px;
      border: solid 2px ${({ theme }) => theme.palette.grey};
    }
  }
`;

export const StyledResponsiveHotelNameFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 12px;
  border-radius: 8px;
  .setur-collapse-content-box {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;
export const StyledResponsiveHotelClassFilter = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  .setur-collapse-content-box {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const StyledResponsiveSingleSelectionFilterContainer = styled.div`
  padding: 15px 20px 0px 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 0px 0px 0px;
  }
`;

export const StyledResponsiveSingleSelectionFilterItemContainer = styled.div`
  margin-bottom: 20px;
`;

export const NonCollapsableFilterContainer = styled.div`
  width: 100%;
  height: 54px;
  padding: 15px 13px 15px 15px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: space-between;
`;

export const NonCollapsableFilterLeftItems = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterRightItems = styled.div`
  margin-top: 3px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.eclipse};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterLeftText = styled.div`
  margin-left: 5px;
`;

export const NonCollapsableFilterRightText = styled.div`
  margin-right: 5px;
`;

export const RadioGroupContainer = styled.div`
  padding: 12px 0px 40px 0px;
`;
